import { NgModule } from '@angular/core';
import { RSCommonModule } from 'src/app/core/feature-modules/facade.module';
import { FormsModule } from '@angular/forms';
import { AbpUtmFormComponent } from './abp-utm-form.component';
import { AbpUtmFieldChooserComponent } from './abp-utm-field-chooser.component';

@NgModule({
  imports: [RSCommonModule, FormsModule],
  declarations: [AbpUtmFormComponent, AbpUtmFieldChooserComponent],
  exports: [AbpUtmFormComponent, AbpUtmFieldChooserComponent],
})
export class AbpUtmFormModule {}
